export const layoutTypes = {
    simple: 'simple',
    default: 'default',
    empty: 'empty',
};
